
import { timeRangeOptions } from "@/utils/options";


const dateTypeOptions = [
    {id: 'CreateTime', text: '创建时间'},
    {id: 'ExpectDeliveryDate', text: '预计交货日期'},
    {id: 'ActualDeliveryDate', text: '实际交货日期'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '供应商',
    prop: 'supplierCode',
    components: [{
        name: 'gj-supplier-select',
        prop: 'supplierCode',
        propsData: {
            placeholder: '供应商'
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '采购仓',
    prop: 'warehouseId',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseId',
        propsData: {
            placeholder: '采购仓',
            fba: false
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '创建人',
    prop: 'createUser',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-creator-select',
        prop: 'createUser',
        propsData: {
            placeholder: '创建人'
        }
    }],
    defaultValue: ''
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}]
